import {InjectionToken} from "@angular/core";
import type {UIRouterGlobals} from "@uirouter/angularjs";

/** Definerer metoder fra ajs @uirouter {@link UIRouterGlobals} som vi benytter i ng2-koden */
export interface AjsUIRouterGlobals extends Pick<UIRouterGlobals, 'params'> {
}

export const ajs_AjsUIRouterGlobals_DI_TOKEN = new InjectionToken<AjsUIRouterGlobals>('ajs AjsUIRouterGlobals');
